export default {
  tooltip_title: 'Napsauta kopioidaksesi',
  success: 'Kopioitu!',
};
